<template>
  <div class="bgBox">
    <div class="bannerBox">
      <img src="../../assets/image/diagram.png" alt="">
    </div>
    <div class="banbutom">
      <div class="top-a">
        <el-input v-model="qrCodeId" placeholder="请输入要搜索的内容或关键字"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="primary"></el-button>
      </div>
      <div class="span-top">
        查询结果
      </div>
      <el-table border :show-header="false" :data="tableData" :highlight-current-row='false' :cell-style="changeCellStyle">
        <el-table-column prop="key" width="200" align='center'>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <span style="margin-left:15px">{{scope.row.value}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      datas: '',
      qrCodeId: ''
    }
  },
  created() {
    this.qrCodeId = this.$route.query.qrCodeId;
    this.primary();

  },
  methods: {
    changeCellStyle(row, column, rowIndex, columnIndex) {
      if (row.column.property == "key") {
        return {
          background: '#F6F7F9',
          color: "#999!important"
        }
      } else {
        return  "color:#787878!important";
      }
    },
    primary() {
      if (this.qrCodeId) {
        this.$axiosGet(this.$store.state.Real_url + "/scan/code/verify/v2", {
          qrCodeId: this.qrCodeId
        }).then(res => {
          if (res.code == 200) {
            this.tableData = res.data.list
          } else {
            this.$message.error(res.message)
          }
        })
      }

    },
  }

}
</script>
<style lang="scss" scoped>
.bgBox {
  padding: 20px 0;
  // background: #f6f7f9;
}
.bannerBox {
  width: 100%;
  height: 360px;
  img {
    width: 100%;
    height: 360px;
    background-repeat: no-repeat;
  }
}
.banbutom {
  width: 1200px;
  height: 600px;
  margin: 0 auto;
  // display: flex;
  // justify-content: space-around;
  // align-items: center;
  // background: #f6f7f9;
  .top-a {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 30px;
    .el-button {
      font-size: 24px;
      padding: 0;
      height: 40px;
      line-height: 40px;
      text-align: center;
      width: 120px;
      background: #1C77FF;
      border-color: #1C77FF;
    }
  }
  .span-top {
    height: 20px;
    width: 150px;
    margin-bottom: 30px;
    font-weight: bold;
    font-weight: 600;
  }
  .span-top::before{
    content: '';
    border-left: 6px solid #1C77FF;
    margin-right: 10px;
  }
}
.el-input {
  width: 974px;
  margin-right: 12px;
}
::v-deep.el-table tbody tr {
  pointer-events: none;
}
</style>